/* eslint-enable */

class FeaturedContentTextImageOverflow {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$module4 = this.sectionsContainer.querySelector('.featured-content-text-image-overflow');
		
		if (!this.$module4)
			return;
		
		this.$module4Elements = this.$module4.querySelectorAll('.anima');
		this.$module4Image = this.$module4.querySelectorAll('.image');
	
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
        gsap.set(this.$module4, { opacity: 0.0001});
        gsap.set(this.$module4Image, { opacity: 0.0001, yPercent: 5});
        gsap.set(this.$module4Elements, {  yPercent: 20, opacity: 0.0001, onComplete: () => {
			this.initAnimate();
		} });
	}

	initAnimate() {
		this.animateModule4 = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$module4,
				start: 'top 70%'
			},
			onComplete: () => {
				gsap.set(this.$module4Elements, { clearProps: true });
				gsap.set(this.$module4Image, { clearProps: true });
			}
        });
    
        this.animateModule4.addLabel('step1');
        this.animateModule4.to(this.$module4, { opacity: 1 }, 'step1');
        this.animateModule4.to(this.$module4Image, { opacity: 1, yPercent: 0 }, 'step1');
		this.animateModule4.to(this.$module4Elements, { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default FeaturedContentTextImageOverflow;
